import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M22.5 0H24c0 8.18-4.54 12-6.77 13.34v.05l1.47 2.89a2.08 2.08 0 0 1-.94 2.79 2 2 0 0 1-2.76-.74l-.34-.78-.66.18V24h-1.49v-5.85l-1 .27-2.21 4.2a2.16 2.16 0 0 1-1.92 1.17 2.22 2.22 0 0 1-1.59-.695 2.1 2.1 0 0 1-.44-.725 2.17 2.17 0 0 1 .06-1.66l2.82-6.13v-2.44l-2.47 1.4a.75.75 0 0 1-.62.05.7.7 0 0 1-.47-.34L2.52 9.42a2 2 0 0 1 .84-2.74A2 2 0 0 1 6 7.54l.52.97L8.1 7.6a2.8 2.8 0 0 1 1.38-.37h4.09a1.24 1.24 0 0 0 1.08-.61L16.19 4a2 2 0 0 1 2.33-.93 2 2 0 0 1 1.25 1.17 2 2 0 0 1-.1 1.7l-2.44 5.59C19.34 10 22.5 6.65 22.5 0M3.79 8.69l1.81 3.2 2.99-1.73a.75.75 0 0 1 1.12.65v3l5.43-1.18 3.2-7.35a.6.6 0 0 0 .06-.49.52.52 0 0 0-.32-.29.52.52 0 0 0-.59.25l-1.55 2.63a2.75 2.75 0 0 1-2.37 1.35H9.48c-.221 0-.438.06-.63.17l-2.24 1.27a.72.72 0 0 1-.57.07.74.74 0 0 1-.46-.35l-.92-1.63A.53.53 0 0 0 4 8a.5.5 0 0 0-.21.31.5.5 0 0 0 0 .38m13.629 8.53a.6.6 0 0 0-.059-.22l-1.47-2.94L9.5 15.4l-2.72 5.94a.61.61 0 0 0 0 .51.67.67 0 0 0 .34.38.68.68 0 0 0 .88-.3l2.33-4.5a.76.76 0 0 1 .47-.37l4.09-1.04a.75.75 0 0 1 .89.42l.58 1.34c.16.28.73 0 .73 0a.58.58 0 0 0 .329-.56"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.528 5.977a2.75 2.75 0 1 1-3.056-4.574 2.75 2.75 0 0 1 3.056 4.574m-.834-3.326a1.25 1.25 0 1 0-1.388 2.078 1.25 1.25 0 0 0 1.388-2.078"
      clipRule="evenodd"
    />
  </>
);

const RockClimbing = Icon('rock-climbing', svgContents);

export default RockClimbing;
